import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api/api.service';
import {
  FeedbackSection,
  FeedbackValue,
  PulseAISummaryFilters,
  PulseAISummaryAvailabilityResponse,
  PulseAISummaryGenerationResponse,
  PulseAISummaryFeedbackPayload,
  PulseAISummaryFeedbackResponse,
  PulseAISummaryFeedbackStatusResponse,
} from './types';

export * from './types';

@Injectable({
  providedIn: 'root',
})
export class PulseAiSummaryService {
  constructor(private apiService: ApiService) {}

  checkAvailability(
    type: string,
    hashId: string,
    filters: PulseAISummaryFilters,
  ): Observable<PulseAISummaryAvailabilityResponse> {
    const path = 'ai/summary/availability';
    const payload = {
      type,
      hash_id: hashId,
      filters,
    };

    return this.apiService.post(path, payload);
  }

  generateSummary(
    type: string,
    hashId: string,
    filters: PulseAISummaryFilters,
  ): Observable<PulseAISummaryGenerationResponse> {
    const path = 'ai/summary';
    const payload = {
      type,
      hash_id: hashId,
      filters,
    };

    return this.apiService.post(path, payload);
  }

  submitFeedback(
    section: FeedbackSection,
    feedback: FeedbackValue,
    hashId: string,
    pulseAiResultId: number,
    filters?: PulseAISummaryFilters,
  ): Observable<PulseAISummaryFeedbackResponse> {
    const path = 'ai/summary/feedback';
    const payload: PulseAISummaryFeedbackPayload = {
      summary_type: 'pulse',
      section,
      feedback,
      hash_id: hashId,
      pulse_ai_result_id: pulseAiResultId,
    };

    if (filters) {
      payload.filters = filters;
    }

    return this.apiService.post(path, payload);
  }

  getFeedbackStatus(pulseAiResultId: number): Observable<PulseAISummaryFeedbackStatusResponse> {
    const path = `ai/summary/feedback?pulse_ai_result_id=${pulseAiResultId}`;
    return this.apiService.get(path);
  }
}
